import { BrowserType, MenuButtonEnum, NotificationTypeEnum } from '../../constants.js'

const objFunc = () => {
  return {
    sidebarOpen: false,
    multipleAccounts: false,
    header: {
      buttonType: MenuButtonEnum.none
    },
    ariaHeader: '',
    showAllLoansToggle: false,
    showAllLoans: true,
    allowScroll: true,
    preventHeaderClick: false,

    // Quick Message
    quickMessageText: '',
    quickMessageType: NotificationTypeEnum.success,

    /**
     * If the device/browser info has already been set, this prevents it being run again.
     */
    hasSetDeviceBrowser: false,

    /**
     * The built-in Chrome/Edge PWA installation prompt action. Use this to trigger the install prompt again.
     */
    pwaDeferredPrompt: undefined,
    isMobileBrowser: false,
    isTabletBrowser: false,
    mobileOs: false,
    desktopOs: false,
    browserType: BrowserType.Unknown,

    /**
     * This is supported by most Chromium based browsers (Chrome, Edge, Samsung Browser, etc.).
     */
    supportsPwaPrompt: false,
    isPwa: false,
    forceWait: false,
    wideViewport: false
  }
}

export default objFunc()

export const defaultObj = objFunc()
